import { DISCUSSION_GET } from '../queries';
import { useQuery } from './base';
export const useDiscussionQuery = ({ externalId, endpoint, }) => {
    return useQuery(['discussion'], DISCUSSION_GET, endpoint, { externalId });
};
//# sourceMappingURL=useDiscussionQuery.js.map